import db from "@/components/firebaseInit";
import APIs from "@/components/APIInit";
import axios from "axios";


export default {
	AddUserAction_old: async function (
		eventcollectionname: string,
		eventName: string,
		page: string,
		action: string,
		actiontype: string,
		actionLabel: string,
		UID: string,
		Uname: string,
		UserEmail: string
	) {
		const obj = JSON.parse(window.localStorage["my-app"])
		var event_collectionName = eventcollectionname;
		var _ClientIP = '';
		if (obj.ClientIP !== undefined) {
			_ClientIP = obj.ClientIP
		}
		db.collection(event_collectionName)
			.doc("Analytics")
			.collection("UserAction")
			.add({
				event: eventName,
				page: page,
				action: action,
				actionType: actiontype,
				actionLabel: actionLabel,
				UID: UID,
				Uname: Uname,
				UserEmail: UserEmail,
				userAgent: navigator.userAgent,
				timestamp: new Date(),
				ClientIP: _ClientIP
			})
			.then(function () {
				console.log("Document successfully written!");
			})
			.catch(function (error) {
				console.error("Error writing document: ", error);
			});
	},

	AddUserLogin_old: async function (
		eventcollectionname: string,
		eventName: string,
		page: string,
		action: string,
		actiontype: string,
		actionLabel: string,
		UID: string,
		Uname: string,
		UserEmail: string,
		ClientIP: string,
	) {

		var event_collectionName = eventcollectionname;
		db.collection(event_collectionName)
			.doc("Analytics")
			.collection("UserLogin")
			.add({
				event: eventName,
				page: page,
				action: action,
				actionType: actiontype,
				actionLabel: actionLabel,
				UID: UID,
				Uname: Uname,
				UserEmail: UserEmail,
				userAgent: navigator.userAgent,
				UserIP: ClientIP,
				timestamp: new Date()
			})
			.then(function () {
				console.log("Document successfully written!");
			})
			.catch(function (error) {
				console.error("Error writing document: ", error);
			});
	},

	AddUserLogin: async function (
		eventcollectionname: string,
		eventName: string,
		page: string,
		action: string,
		actiontype: string,
		actionLabel: string,
		UID: string,
		Uname: string,
		UserEmail: string
	) {
		const obj = JSON.parse(window.localStorage["my-app"])
		var LoginType = '';
		if (actionLabel == "Login") {
			LoginType = "NORMAL";
		}
		else {
			LoginType = "GOOGLE";
		}
		var postData = {
			instanceId: "OA_UAT",
			clientId: obj.client[0].id,
			eventId: obj.eventid,
			userId: UID,
			userName: Uname,
			userEmail: UserEmail,
			loginType: LoginType
		};
		let headers = {
			"Content-Type": "application/json",
		};
		axios
			.post(
				APIs.AnalyticsUserLogin,
				JSON.stringify(postData),
				{
					headers: headers,
				}
			)
			.then((data) => {
				console.log(data);
			})
			.catch((error) => {
				console.log(error);
			});
	},

	AddUserAction: async function (
		eventcollectionname: string,
		eventName: string,
		page: string,
		action: string,
		actiontype: string,
		actionLabel: string,
		UID: string,
		Uname: string,
		UserEmail: string
	) {
		const obj = JSON.parse(window.localStorage["my-app"])
		var postData = {
			instanceId: "OA_UAT",
			clientId: obj.client[0].id,
			eventId: obj.eventid,
			origin: "Responsive",
			userId: UID,
			userName: Uname,
			userEmail: UserEmail,
			action: action,
			actionLabel: actionLabel,
			actionType: actiontype,
			pageName: page,
			eventName: eventName
		};
		let headers = {
			"Content-Type": "application/json",
		};
		axios
			.post(
				APIs.AnalyticsUserAction,
				JSON.stringify(postData),
				{
					headers: headers,
				}
			)
			.then((data) => {
				console.log(data);
			})
			.catch((error) => {
				console.log(error);
			});
	},

	AddUserView: async function (
		eventcollectionname: string,
		eventName: string,
		page: string,
		action: string,
		actiontype: string,
		actionLabel: string,
		UID: string,
		Uname: string,
		UserEmail: string
	) {
		const obj = JSON.parse(window.localStorage["my-app"])
		var postData = {
			instanceId: "OA_UAT",
			clientId: obj.client[0].id,
			eventId: obj.eventid,
			origin: "Responsive",
			userId: UID,
			userName: Uname,
			userEmail: UserEmail,
			action: action,
			actionLabel: actionLabel,
			actionType: actiontype,
			pageName: page,
			eventName: eventName
		};
		let headers = {
			"Content-Type": "application/json",
		};
		axios
			.post(
				APIs.AnalyticsUserAction,
				JSON.stringify(postData),
				{
					headers: headers,
				}
			)
			.then((data) => {
				console.log(data);
			})
			.catch((error) => {
				console.log(error);
			});
	}
}